import { useState } from "react";
import Button from "components/button";
import SideDrawer from "components/drawer";
import InviteStaffForm from "./invite-staff-form";

const FORM_ID = "invite-staff-form";

const InviteStaffDrawer = ({ isOpen, onClose, onInviteSent }) => {
  const [sending, setSending] = useState(false);

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Invite Staff Member"
      subtitle="Send an invitation to join your organization"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" form={FORM_ID} loading={sending}>
            {sending ? "Sending…" : "Send Invitation"}
          </Button>
        </>
      }
    >
      <InviteStaffForm
        formId={FORM_ID}
        onClose={onClose}
        onSendingChange={setSending}
        onInviteSent={onInviteSent}
      />
    </SideDrawer>
  );
};

export default InviteStaffDrawer;
